module.exports = __webpack_public_path__ + "static/media/main_camshafts.3a3e1e8b.jpg";